import graphQl from '../../../../services/graphQl';
import { Commit, ActionTree, MutationTree, Dispatch } from 'vuex';
import { State } from './topology.store';
import axios, { AxiosPromise, AxiosResponse } from 'axios';
import { Call, EndpointDependencyConidition, Duration } from './topology.store';
import { UNKNOWN_SERVER } from '@/utils/constants';
import { AuthService } from '@/services/api/auth.service';
import axiosInstance from '@/services/api/http.service';
import getEnv from '@/utils/env';
import { permissionTypes } from '@/router/constant';
interface Node {
  apdex: number;
  avgResponseTime: number;
  cpm: number;
  id: string;
  isAlarm: boolean;
  name: string;
  numOfServer: number;
  numOfServerAlarm: number;
  numOfServiceAlarm: number;
  sla: number;
  type: string;
}
//const OAP_HOST = 'http://localhost:3000';

const OAP_HOST = getEnv('VUE_APP_OAP_HOST') || 'http://localhost:12800';

const actions: ActionTree<State, any> = {
  getServices(
    context: { commit: Commit },
    params: { duration: Duration; keyword: string },
  ) {
    if (!params.keyword) {
      params.keyword = '';
    }
    return graphQl
      .query('queryServices')
      .params(params)
      .then((res: AxiosResponse) => {
        return res.data.data.services || [];
      });
  },
  GET_SERVICE_ENDPOINTS(
    context: { commit: Commit },
    params: { serviceId: string; keyword: string },
  ) {
    if (!params.serviceId) {
      return new Promise<void>((resolve) => resolve());
    }
    if (!params.keyword) {
      params.keyword = '';
    }
    return graphQl
      .query('queryEndpoints')
      .params(params)
      .then((res: AxiosResponse) => {
        return res.data.data.getEndpoints || [];
      })
      .catch((error) => console.log('error', error));
  },
  CLEAR_TOPO(context: { commit: Commit; state: State }) {
    context.commit('setTopo', { calls: [], nodes: [] });
  },
  CLEAR_TOPO_INFO(context: { commit: Commit; state: State }) {
    context.commit('setTopoRelation', {});
    context.commit('setSelectedCall', null);
  },
  GET_INSTANCE_DEPENDENCY_METRICS(
    context: { commit: Commit; state: State; dispatch: Dispatch; getters: any },
    params: any,
  ) {
    if (params.mode === 'SERVER') {
      params.queryType = 'queryTopoInstanceServerInfo';
      context.dispatch('INSTANCE_RELATION_INFO', params);
    }
    if (params.mode === 'CLIENT') {
      params.queryType = 'queryTopoInstanceClientInfo';
      context.dispatch('INSTANCE_RELATION_INFO', params);
    }
  },
  GET_TOPO_SERVICE_INFO(
    context: { commit: Commit; state: State },
    params: { id: string; duration: Duration },
  ) {
    if (!params.id) {
      return;
    }
    return graphQl
      .query('queryTopoServiceInfo')
      .params({
        id: params.id,
        duration: params.duration,
      })
      .then((res: AxiosResponse) => {
        if (!res.data.data) {
          return;
        }
        context.commit('setTopoRelation', res.data.data);
        context.commit('setSelectedCall', params);
      })
      .catch((error) => console.log('error', error));
  },
  GET_TOPO_CLIENT_INFO(context: { commit: Commit; state: State }, params: any) {
    return graphQl
      .query('queryTopoClientInfo')
      .params(params)
      .then((res: AxiosResponse) => {
        if (!res.data.data) {
          return;
        }
        context.commit('setTopoRelation', res.data.data);
        context.commit('setSelectedCall', params);
      })
      .catch((error) => console.log('error', error));
  },
  GET_TOPO_SERVICE_DETAIL(
    context: { commit: Commit; state: State },
    params: { serviceId: string; duration: Duration },
  ) {
    return graphQl
      .query('queryTopoServiceDetail')
      .params({
        serviceId: params.serviceId,
        duration: params.duration,
      })
      .then((res: AxiosResponse) => {
        if (!res.data.data) {
          return;
        }
        context.commit('setServiceDetail', res.data.data);
      })
      .catch((error) => console.log('error', error));
  },
  getTopo(
    context: { commit: Commit; state: State },
    params: any,
  ): Promise<void> {
    let query = 'queryTopo';
    if (params.serviceId) {
      query = 'queryServiceTopo';
    }
    if (params.serviceIds) {
      if (params.serviceIds.length === 0) {
        return new Promise((resolve) => resolve());
      } else {
        query = 'queryServicesTopo';
      }
    } else if (!params.serviceId) {
      return new Promise((resolve) => resolve());
    }
    return graphQl
      .query(query)
      .params(params)
      .then(async (res: AxiosResponse) => {
        const realNodes = res.data.data.topo.nodes.filter(
          (node) => node.isReal,
        );

        const serviceAccessList = realNodes.reduce(
          (acc, realNode) => {
            const id = realNode.id?.split?.('_')?.[0];
            const serviceAccessMap = [
              {
                resource: id,
                resourceGroup: 'A',
                permission: permissionTypes.READ,
              },
              {
                resource: id,
                resourceGroup: 'A',
                permission: permissionTypes.WRITE,
              },
            ];
            acc.push(...serviceAccessMap);
            return acc;
          },
          [] as Record<string, any>,
        );
        const permissions =
          await AuthService.fetchServicesPermissions(serviceAccessList);

        const calls = res.data.data.topo.calls;
        const nodes = res.data.data.topo.nodes.map((node) => ({
          ...node,
          permissions: permissions[node?.id?.split('_')?.[0]],
        }));

        const ids = nodes.map((i: any) => i.id);
        nodes.map((i: any) => {
          if (!i.name) {
            i.name = UNKNOWN_SERVER;
          }
          return i;
        });
        const idsC = calls
          .filter((i: any) => i.detectPoints.indexOf('CLIENT') !== -1)
          .map((b: any) => b.id);
        const idsS = calls
          .filter((i: any) => i.detectPoints.indexOf('CLIENT') === -1)
          .map((b: any) => b.id);
        return graphQl
          .query('queryTopoInfo')
          .params({
            ...params,
            // ids, idsC, idsS,
            metric: [
              {
                name: 'service_sla',
                alias: 'sla',
                ids: ids,
              },
              {
                name: 'service_apdex',
                alias: 'apdex',
                ids: ids,
              },
              {
                name: 'service_cpm',
                alias: 'nodeCpm',
                ids: ids,
              },
              {
                name: 'service_resp_time',
                alias: 'nodeLatency',
                ids: ids,
              },
              {
                name: 'service_relation_server_cpm',
                alias: 'cpmS',
                ids: idsS,
              },
              {
                name: 'service_relation_server_resp_time',
                alias: 'latencyS',
                ids: idsS,
              },
              {
                name: 'service_relation_client_cpm',
                alias: 'cpmC',
                ids: idsC,
              },
              {
                name: 'service_relation_client_resp_time',
                alias: 'latencyC',
                ids: idsC,
              },
            ],
          })
          .then((info: AxiosResponse) => {
            function formatIdsByOrder<T extends { id: string }>(
              array: T[],
              order: string[],
            ): T[] {
              const orderMap = new Map(order.map((id, index) => [id, index]));
              return array.sort((a, b) => {
                return (
                  (orderMap.get(a.id) ?? Infinity) -
                  (orderMap.get(b.id) ?? Infinity)
                );
              });
            }

            function getIdsList(key) {
              if (
                key === 'sla' ||
                key === 'apdex' ||
                key === 'nodeCpm' ||
                key === 'nodeLatency'
              ) {
                return ids;
              }
              if (key === 'cpmS' || key === 'latencyS') {
                return idsS;
              }
              if (key === 'cpmC' || key === 'latencyC') {
                return idsC;
              }
              return [];
            }

            function createObjectFromList(array) {
              return array.reduce((accumulator, currentItem) => {
                accumulator[currentItem.key] = {
                  values: formatIdsByOrder(
                    currentItem.values.values,
                    getIdsList(currentItem.key),
                  ),
                };
                return accumulator;
              }, {});
            }

            const resInfo =
              // info.data.data;
              createObjectFromList(info.data.data.getMetricAggregatedValues);
            if (!resInfo.sla) {
              return context.commit('setTopo', { calls, nodes });
            }
            for (let i = 0; i < resInfo.sla.values.length; i += 1) {
              for (let j = 0; j < nodes.length; j += 1) {
                if (nodes[j].id === resInfo.sla.values[i].id) {
                  nodes[j] = {
                    ...nodes[j],
                    isGroupActive: true,
                    sla: resInfo.sla.values[i].value
                      ? resInfo.sla.values[i].value / 100
                      : -1,
                    apdex: resInfo.apdex.values[i].value
                      ? resInfo.apdex.values[i].value / 10000
                      : -1,
                    cpm: resInfo.nodeCpm.values[i]
                      ? resInfo.nodeCpm.values[i].value
                      : -1,
                    latency: resInfo.nodeLatency.values[i]
                      ? resInfo.nodeLatency.values[i].value
                      : -1,
                  };
                }
              }
            }
            if (!resInfo.cpmC) {
              return context.commit('setTopo', { calls, nodes });
            }
            for (let i = 0; i < resInfo.cpmC.values.length; i += 1) {
              for (let j = 0; j < calls.length; j += 1) {
                if (calls[j].id === resInfo.cpmC.values[i].id) {
                  calls[j] = {
                    ...calls[j],
                    isGroupActive: true,
                    cpm: resInfo.cpmC.values[i]
                      ? resInfo.cpmC.values[i].value
                      : '',
                    latency: resInfo.latencyC.values[i]
                      ? resInfo.latencyC.values[i].value
                      : '',
                  };
                }
              }
            }
            if (!resInfo.cpmS) {
              return context.commit('setTopo', { calls, nodes });
            }
            for (let i = 0; i < resInfo.cpmS.values.length; i += 1) {
              for (let j = 0; j < calls.length; j += 1) {
                if (calls[j].id === resInfo.cpmS.values[i].id) {
                  calls[j] = {
                    ...calls[j],
                    cpm: resInfo.cpmS.values[i]
                      ? resInfo.cpmS.values[i].value
                      : '',
                    latency: resInfo.latencyS.values[i]
                      ? resInfo.latencyS.values[i].value
                      : '',
                  };
                }
              }
            }
            context.commit('setTopo', { calls, nodes });
          })
          .catch((error) => error);
      })
      .catch((error) => console.log('error', error));
  },
  // todo sync
  GET_ALL_ENDPOINT_DEPENDENCY(
    context: { commit: Commit; state: State; dispatch: Dispatch },
    params: { endpointIds: string[]; duration: Duration },
  ) {
    context
      .dispatch('GET_ENDPOINT_TOPO', params)
      .then((res) => {
        if (!res) {
          return;
        }
        if (context.state.currentEndpointDepth.key > 1) {
          const endpointIds = res.nodes.map((item: Node) => item.id);

          context
            .dispatch('GET_ENDPOINT_TOPO', {
              endpointIds,
              duration: params.duration,
            })
            .then((json) => {
              if (context.state.currentEndpointDepth.key > 2) {
                const ids = json.nodes.map((item: Node) => item.id);

                context
                  .dispatch('GET_ENDPOINT_TOPO', {
                    endpointIds: ids,
                    duration: params.duration,
                  })
                  .then((topo) => {
                    if (context.state.currentEndpointDepth.key > 3) {
                      const endpoints = topo.nodes.map((item: Node) => item.id);
                      context
                        .dispatch('GET_ENDPOINT_TOPO', {
                          endpointIds: endpoints,
                          duration: params.duration,
                        })
                        .then((data) => {
                          if (context.state.currentEndpointDepth.key > 4) {
                            context
                              .dispatch('GET_ENDPOINT_TOPO', {
                                endpointIds: endpoints,
                                duration: params.duration,
                              })
                              .then((topos) => {
                                context.commit('setEndpointDependency', topos);
                              })
                              .catch((error) => error);
                          } else {
                            context.commit('setEndpointDependency', data);
                          }
                        })
                        .catch((error) => error);
                    } else {
                      context.commit('setEndpointDependency', topo);
                    }
                  })
                  .catch((error) => error);
              } else {
                context.commit('types.SET_ENDPOINT_DEPENDENCY', json);
              }
            })
            .catch((error) => error);
        } else {
          context.commit('setEndpointDependency', res);
        }
      })
      .catch((error) => console.log('error', error));
  },
  GET_ENDPOINT_TOPO(
    context: { commit: Commit; state: State },
    params: { endpointIds: string[]; duration: Duration },
  ) {
    const variables = ['$duration: Duration!'];
    const fragment = params.endpointIds.map((id: string, index: number) => {
      return `endpointTopology${index}: getEndpointDependencies(endpointId: "${id}", duration: $duration) {
           nodes {
             id
             name
             serviceId
             serviceName
             type
             isReal
           }
           calls {
             id
             source
             target
             detectPoints
           }
         }`;
    });
    const querys = `query queryData(${variables}) {${fragment}}`;
    const username = window.localStorage.getItem('skywalking-username');
    const token = window.localStorage.getItem('skywalking-token');
    const permissionToken = window.localStorage.getItem('permission');
    axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

    new axiosInstance({ auth: true })
      .post(
        OAP_HOST + '/graphql',
        { query: querys, variables: { duration: params.duration } },
        {
          //   cancelToken: cancelToken()
        },
      )
      .then((res: AxiosResponse) => {
        if (res.data.errors) {
          context.commit('setEndpointDependency', {
            calls: [],
            nodes: [],
          });
          return;
        }
        const topo = res.data.data;
        const calls = [] as any;
        let nodes = [] as any;
        for (const key of Object.keys(topo)) {
          calls.push(...topo[key].calls);
          nodes.push(...topo[key].nodes);
        }
        if (!nodes.length) {
          context.commit('setEndpointDependency', {
            calls: [],
            nodes: [],
          });
          return;
        }
        const obj = {} as any;
        nodes = nodes.reduce((prev: Node[], next: Node) => {
          if (!obj[next.id]) {
            obj[next.id] = true;
            prev.push(next);
          }
          return prev;
        }, []);
        const queryVariables = ['$duration: Duration!'];
        const fragments = calls
          .map((call: Call & EndpointDependencyConidition, index: number) => {
            let source = {} as any;
            let target = {} as any;
            for (const node of nodes) {
              if (node.id === call.source) {
                source = node;
                call.serviceName = node.serviceName;
                call.endpointName = node.name;
              }
              if (node.id === call.target) {
                target = node;
                call.destServiceName = node.serviceName;
                call.destEndpointName = node.name;
              }
            }
            return `cpm_${index}: readMetricsValue(condition: {
               name: "endpoint_relation_cpm"
               entity: {
                 scope: EndpointRelation
                 serviceName: "${source.serviceName}"
                 normal: true
                 endpointName: "${source.name}"
                 destNormal: true
                 destServiceName: "${target.serviceName}"
                 destEndpointName: "${target.name}"
               }
             }, duration: $duration)`;
          })
          .join(' ');
        const query = `query queryData(${queryVariables}) {${fragments}}`;
        new axiosInstance({ auth: true })
          .post(
            OAP_HOST + '/graphql',
            { query, variables: { duration: params.duration } },
            {
              //   cancelToken: cancelToken()
            },
          )
          .then((json: AxiosResponse<any>) => {
            if (json.data.errors) {
              context.commit('setEndpointDependency', {
                calls: [],
                nodes: [],
              });
              return;
            }
            const cpms = json.data.data;
            const keys = Object.keys(cpms);
            for (const key of keys) {
              const index = Number(key.split('_')[1]);
              calls[index].value = cpms[key] || 0.01;
            }
            return { calls, nodes };
          })
          .catch(() => {
            context.commit('setEndpointDependency', {
              calls: [],
              nodes: [],
            });
          });
      })
      .catch((error) => console.log('error', error));
  },
  GET_TOPO_INSTANCE_DEPENDENCY(
    context: { commit: Commit; state: State },
    params: {
      clientServiceId: string;
      serverServiceId: string;
      duration: Duration;
    },
  ) {
    graphQl
      .query('queryTopoInstanceDependency')
      .params(params)
      .then((res: AxiosResponse) => {
        if (!(res.data && res.data.data)) {
          return;
        }
        const clientIdsC = [] as string[];
        const serverIdsC = [] as string[];
        const topoCalls = res.data.data.topo.calls;
        for (const call of topoCalls) {
          if (call.detectPoints.includes('CLIENT')) {
            clientIdsC.push(call.id);
          } else {
            serverIdsC.push(call.id);
          }
        }
        let callback;
        let callbackServer;
        if (clientIdsC.length) {
          callback = graphQl
            .query('queryDependencyInstanceClientMetric')
            .params({
              idsC: clientIdsC,
              duration: params.duration,
            })
            .then((json: AxiosResponse) => {
              const clientCalls = [] as string[];
              for (const call of topoCalls) {
                for (const cpm of json.data.data.cpmC.values) {
                  if (cpm.id === call.id) {
                    clientCalls.push({
                      ...call,
                      ...cpm,
                    });
                  }
                }
              }
              return clientCalls;
            })
            .catch((error) => error);
        } else {
          callback = new Promise((resolve) => resolve([]));
        }
        if (serverIdsC.length) {
          callbackServer = graphQl
            .query('queryDependencyInstanceServerMetric')
            .params({
              idsC: serverIdsC,
              duration: params.duration,
            })
            .then((jsonResp: AxiosResponse) => {
              const serverCalls = [] as string[];
              for (const call of topoCalls) {
                for (const cpm of jsonResp.data.data.cpmC.values) {
                  if (cpm.id === call.id) {
                    serverCalls.push({
                      ...call,
                      ...cpm,
                    });
                  }
                }
              }
              return serverCalls;
            })
            .catch((error) => error);
        } else {
          callbackServer = new Promise((resolve) => resolve([]));
        }
        Promise.all([callback, callbackServer]).then((values: any) => {
          const instanceDependency = {
            nodes: res.data.data.topo.nodes,
            calls: [...values[0], ...values[1]],
          };
          context.commit('setInstanceDependency', instanceDependency);
        });
      })
      .catch((error) => console.log('error', error));
  },
  INSTANCE_RELATION_INFO(
    context: { commit: Commit; state: State },
    params: Call & { mode: string; queryType: string; durationTime: Duration },
  ) {
    graphQl
      .query(params.queryType)
      .params({
        id: params.id,
        duration: params.durationTime,
      })
      .then((res: AxiosResponse) => {
        if (!(res.data && res.data.data)) {
          return;
        }
        context.commit('setSelectedInstanceCall', params);
        context.commit('setInstanceDependenceType', params.mode);
        context.commit('setInstanceDependenceMetrics', res.data.data);
      })
      .catch((error) => console.log('error', error));
  },
  GET_ENDPOINT_DEPENDENCY_METRICS(
    context: { commit: Commit; state: State },
    params: EndpointDependencyConidition,
  ) {
    return graphQl
      .query('queryTopoEndpointDependencyMetrics')
      .params(params)
      .then((res: AxiosResponse) => {
        if (!(res.data && res.data.data)) {
          return;
        }
        context.commit('setInstanceDependenceMetrics', res.data.data);
      });
  },
};

export default actions;
